
<script>
import moment from 'moment';
import Loader from '../components/Loader';

export default {
    components: { Loader },

    filters: {
        discountPercentage(discountedPrice, originalPrice) {
            return Math.round(100 - ((discountedPrice * 100) / originalPrice));
        },

        postedTime(createdDate) {
            let width = window.innerWidth;

            if (width < 510) {
                return moment(createdDate).fromNow(true);
            }
            return moment(createdDate).fromNow();
        },

        truncateTitle(title) {
            if (title.length > 50) {
                return `${title.substring(0, 50)} ...`;
            }
            return title;
        },
    },

    props: { deal: Object },

    data() {
        return {
            isLoading: false,
            timer: null,
            isActive: false,
            title: null,
        };
    },

    created() {
        this.title = this.deal.title.replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();
    },

    methods: {

        isExpired(expiryDate) {
            return moment(expiryDate).isBefore(moment());
        },

        navigateToDeal(deal) {
            let title = deal.title.replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();
            this.$router.push(`/deal/${deal.id}/${title}`);
        },

        navigateToDealViaImage(deal) {
            if (!this.isActive) {
                this.isActive = true;
                return;
            }
            let title = deal.title.replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();
            this.$router.push(`/deal/${deal.id}/${title}`);
        },

        filterByRetailer(retailer) {
            window.scrollTo(0, 0);
            this.$store.dispatch('addRetailersFilter', retailer.name);
            this.$store.dispatch('debounceDeals');
        },

        filterByUser(user) {
            if (!this.isActive) return;
            window.scrollTo(0, 0);
            this.$router.push(`?search=${user}`);
        },

        /**
         * Like or unlike the deal
         */
        async likeDeal() {
            const likeOrUnlike = this.deal.liked ? 'unlike' : 'like';

            let response = {};
            this.isLoading = true;
            try {
                response = await window.axios.post(`/api/deals/${this.deal.id}/${likeOrUnlike}`);
            } catch (error) {}

            this.isLoading = false;

            if (response.status < 300) {
                this.deal.liked = !this.deal.liked;

                if (this.deal.liked) {
                    this.deal.star_count += 1;
                } else {
                    this.deal.star_count -= 1;
                }
            } else {
                this.isLoading = false;
            }
        },
    },
};
</script>


<template lang="pug" src='./template/DealCard.pug' />
<style lang="stylus" scoped src='./styles/DealCard.styl' />
